export default __webpack_public_path__ + "static/media/load-animation.2c2fbd6c.svg";